import React from 'react';

/**
 * 스켈레톤 카드 (로딩 중 표시)
 */
export const SkeletonCard: React.FC = () => {
  return (
    <div className="card-azocsii animate-pulse">
      <div className="h-6 bg-gray-200 rounded w-3/4 mb-4"></div>
      <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
      <div className="h-4 bg-gray-200 rounded w-2/3"></div>
    </div>
  );
};

/**
 * 스켈레톤 리스트
 */
export const SkeletonList: React.FC<{ count?: number }> = ({ count = 3 }) => {
  return (
    <div className="space-y-4">
      {Array.from({ length: count }).map((_, i) => (
        <SkeletonCard key={i} />
      ))}
    </div>
  );
};

/**
 * 스켈레톤 통계 카드
 */
export const SkeletonStats: React.FC = () => {
  return (
    <div className="grid grid-cols-2 gap-4 mb-6">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="bg-white rounded-xl p-4 shadow-sm animate-pulse">
          <div className="h-4 bg-gray-200 rounded w-1/2 mb-2"></div>
          <div className="h-8 bg-gray-200 rounded w-3/4"></div>
        </div>
      ))}
    </div>
  );
};

/**
 * 스켈레톤 테이블 행
 */
export const SkeletonTableRow: React.FC = () => {
  return (
    <tr className="animate-pulse">
      <td className="px-4 py-3">
        <div className="h-4 bg-gray-200 rounded w-20"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 bg-gray-200 rounded w-24"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 bg-gray-200 rounded w-16"></div>
      </td>
      <td className="px-4 py-3">
        <div className="h-4 bg-gray-200 rounded w-16"></div>
      </td>
    </tr>
  );
};

/**
 * 스켈레톤 달력
 */
export const SkeletonCalendar: React.FC = () => {
  return (
    <div className="bg-white rounded-xl shadow-sm p-4 animate-pulse">
      <div className="h-8 bg-gray-200 rounded w-1/3 mb-4 mx-auto"></div>
      <div className="grid grid-cols-7 gap-2">
        {Array.from({ length: 35 }).map((_, i) => (
          <div key={i} className="aspect-square bg-gray-200 rounded"></div>
        ))}
      </div>
    </div>
  );
};

/**
 * 돈까스 로딩 애니메이션 (귀여운 버전)
 */
export const DonkatsuLoading: React.FC = () => {
  return (
    <div className="flex flex-col items-center justify-center py-12">
      <div className="relative">
        {/* 돈까스 뒤집기 애니메이션 */}
        <div className="text-6xl animate-flip">
          🍖
        </div>
        {/* 불 효과 */}
        <div className="absolute -bottom-2 left-1/2 transform -translate-x-1/2 text-2xl animate-pulse">
          🔥
        </div>
      </div>
      <p className="mt-4 text-gray-600 animate-pulse">
        맛있게 튀기는 중...
      </p>
    </div>
  );
};
